export class Finyearmst {
    finyearmstId?: number
    finyear?: string
    status?: boolean
  
    constructor(init?: Partial<Finyearmst>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class Txncategory {
    txncategoryId?: number
    name?: string
    description?: string
    createdDt?: string
    updatedDt?: string
  
    constructor(init?: Partial<Txncategory>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class Purpose {
    purposeId?: number
    name?: string
    createdDt?: string
    updatedDt?: string
  
    constructor(init?: Partial<Purpose>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class Transaction {
    txnId?: number
    receiptId?: number
    receiptPrefix?: string
    status?: string
    source?: string
    txnDate?: number
    receiptIdPrefixed?: string
  
    constructor(init?: Partial<Transaction>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class AccountsDetails {
    accountsdetailsId?: number
    receiptNo?: number
    salutation?: string
    firstName?: string
    middleName?: string
    lastName?: string
    address?: string
    city?: string
    pinCd?: number
    mobileNbr?: string
    email?: string
    panCrdNbr?: string
    aadharCrdNbr?: string
    notes?: string
    collectedBy?: string
  
    constructor(init?: Partial<AccountsDetails>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class AccountsHeader {
    accountsheaderId?: number
    txndate?: string
    amount?: number
    bookNo?: number
    modeOfPayment?: string
    modeTranId?: string
    modeBankName?: string
    finyearmst = new Finyearmst();
    txncategory = new Txncategory();
    purpose = new Purpose();
    transaction = new Transaction();
    status?: boolean
    mapexternal?: boolean
    receiptLocked?: boolean
  
    constructor(init?: Partial<AccountsHeader>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class TallyReceiptModel {
    accountsHeader: AccountsHeader = new AccountsHeader();
    accountsDetails: AccountsDetails = new AccountsDetails();
    receiptUpdate?: boolean;
    createdBy?: string;
    createdDate?: number;
    updatedBy?: string;
    updatedDate?: number;
  
    constructor(init?: Partial<TallyReceiptModel>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class ChequeNoDTO {
  txncategoryId?: number
  finyearmstId?: number
  chequeNo?: string

  constructor(init?: Partial<ChequeNoDTO>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}